/**
 * Theme metadata, usable by any part of the theme (banner, footer, etc).
 *
 * themeVersionHash: 7-char git SHA of the deployed theme. The placeholder
 *     below is replaced by CI at build time (see ghost-theme.yaml). It is an
 *     all-caps token so it can never be confused with a real SHA.
 * cookiePolicyVersion: monotonic int; bump manually on a material consent-basis
 *     change to force re-consent. NEVER overwritten by CI.
 */
function getThemeMeta() {
  return {
    themeVersionHash: "17faac0",
    cookiePolicyVersion: 1
  };
}
